/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Relay API
 * Energy utility bill analysis API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountManagementServiceDto,
  BackfillRetailersResultDto,
  BackfillRolledOutRollupsResultDto,
  BatchMoveSitesToListDto,
  BillDto,
  ContractFieldsPreviewResultDto,
  CreateAccountManagementServiceDto,
  CreateNoteDto,
  CreateSiteDisputeDto,
  CreateSiteDto,
  EmailDto,
  ImportSiteFromCrmDto,
  MassEditableFieldDto,
  MassUpdateContractFieldsDto,
  MassUpdateContractFieldsResultDto,
  MassUpdateLinkFieldsDto,
  MassUpdateLinkFieldsResultDto,
  MassUpdateSitesDto,
  MassUpdateSitesResultDto,
  MoveSiteToListDto,
  NmiExistsResponseDto,
  NoteDto,
  PaginatedActivityResponseDto,
  PaginatedServiceTrackerResponseDto,
  PaginatedSitesResponseDto,
  RyoBusinessDescriptionDto,
  SearchServiceTrackerResultDto,
  SearchSitesResultDto,
  ServiceTrackerSummaryDto,
  SetEnergyManagerDto,
  SiteDisputeDto,
  SiteDto,
  SiteListDto,
  SitesControllerBackfillRetailersParams,
  SitesControllerCheckNmiExistsParams,
  SitesControllerFindAllParams,
  SitesControllerGetAccountManagementServicesParams,
  SitesControllerGetServiceTrackerParams,
  SitesControllerGetServiceTrackerSummaryParams,
  SitesControllerGetSiteActivityParams,
  SitesControllerGetSiteDisputesParams,
  SitesControllerGetSiteEmailsParams,
  SitesControllerGetSiteNotesParams,
  SitesControllerSearchParams,
  SitesControllerSearchServiceTrackerParams,
  UpdateAccountManagementServiceDto,
  UpdateNoteDto,
  UpdateSiteDisputeDto,
  UpdateSiteDto
} from '.././schemas';

import { customInstance } from '../../client';




/**
 * Sweeps every site and runs the SiteRetailerResolver. Writes the canonical retailer only when a source resolves AND differs from the current value. Never clears an existing retailer. Pass ?onlyEmpty=true to scan only sites whose retailer is missing.
 * @summary Backfill site billingInfo.retailer from contracts/bills
 */
export const sitesControllerBackfillRetailers = (
    params?: SitesControllerBackfillRetailersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BackfillRetailersResultDto>(
      {url: `/sites/backfill-retailers`, method: 'POST',
        params, signal
    },
      );
    }
  


export const getSitesControllerBackfillRetailersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBackfillRetailers>>, TError,{params?: SitesControllerBackfillRetailersParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBackfillRetailers>>, TError,{params?: SitesControllerBackfillRetailersParams}, TContext> => {

const mutationKey = ['sitesControllerBackfillRetailers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerBackfillRetailers>>, {params?: SitesControllerBackfillRetailersParams}> = (props) => {
          const {params} = props ?? {};

          return  sitesControllerBackfillRetailers(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerBackfillRetailersMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerBackfillRetailers>>>
    
    export type SitesControllerBackfillRetailersMutationError = unknown

    /**
 * @summary Backfill site billingInfo.retailer from contracts/bills
 */
export const useSitesControllerBackfillRetailers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBackfillRetailers>>, TError,{params?: SitesControllerBackfillRetailersParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerBackfillRetailers>>,
        TError,
        {params?: SitesControllerBackfillRetailersParams},
        TContext
      > => {

      const mutationOptions = getSitesControllerBackfillRetailersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Recalculate site lists that hold a rolled-out site
 */
export const sitesControllerBackfillRolledOutRollups = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BackfillRolledOutRollupsResultDto>(
      {url: `/sites/backfill-rolled-out-rollups`, method: 'POST', signal
    },
      );
    }
  


export const getSitesControllerBackfillRolledOutRollupsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBackfillRolledOutRollups>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBackfillRolledOutRollups>>, TError,void, TContext> => {

const mutationKey = ['sitesControllerBackfillRolledOutRollups'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerBackfillRolledOutRollups>>, void> = () => {
          

          return  sitesControllerBackfillRolledOutRollups()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerBackfillRolledOutRollupsMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerBackfillRolledOutRollups>>>
    
    export type SitesControllerBackfillRolledOutRollupsMutationError = unknown

    /**
 * @summary Recalculate site lists that hold a rolled-out site
 */
export const useSitesControllerBackfillRolledOutRollups = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBackfillRolledOutRollups>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerBackfillRolledOutRollups>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSitesControllerBackfillRolledOutRollupsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Create a new site
 */
export const sitesControllerCreate = (
    createSiteDto: CreateSiteDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteDto>(
      {url: `/sites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSiteDto, signal
    },
      );
    }
  


export const getSitesControllerCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreate>>, TError,{data: CreateSiteDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreate>>, TError,{data: CreateSiteDto}, TContext> => {

const mutationKey = ['sitesControllerCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerCreate>>, {data: CreateSiteDto}> = (props) => {
          const {data} = props ?? {};

          return  sitesControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerCreate>>>
    export type SitesControllerCreateMutationBody = CreateSiteDto
    export type SitesControllerCreateMutationError = void

    /**
 * @summary Create a new site
 */
export const useSitesControllerCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreate>>, TError,{data: CreateSiteDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerCreate>>,
        TError,
        {data: CreateSiteDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get all sites (paginated)
 */
export const sitesControllerFindAll = (
    params?: SitesControllerFindAllParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedSitesResponseDto>(
      {url: `/sites`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerFindAllQueryKey = (params?: SitesControllerFindAllParams,) => {
    return [
    `/sites`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerFindAll>>, TError = unknown>(params?: SitesControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindAll>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerFindAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerFindAll>>> = ({ signal }) => sitesControllerFindAll(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerFindAll>>>
export type SitesControllerFindAllQueryError = unknown


export function useSitesControllerFindAll<TData = Awaited<ReturnType<typeof sitesControllerFindAll>>, TError = unknown>(
 params: undefined |  SitesControllerFindAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindAll<TData = Awaited<ReturnType<typeof sitesControllerFindAll>>, TError = unknown>(
 params?: SitesControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindAll>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindAll<TData = Awaited<ReturnType<typeof sitesControllerFindAll>>, TError = unknown>(
 params?: SitesControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all sites (paginated)
 */

export function useSitesControllerFindAll<TData = Awaited<ReturnType<typeof sitesControllerFindAll>>, TError = unknown>(
 params?: SitesControllerFindAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindAll>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerFindAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Search/browse sites
 */
export const sitesControllerSearch = (
    params?: SitesControllerSearchParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SearchSitesResultDto>(
      {url: `/sites/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerSearchQueryKey = (params?: SitesControllerSearchParams,) => {
    return [
    `/sites/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerSearch>>, TError = unknown>(params?: SitesControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearch>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerSearch>>> = ({ signal }) => sitesControllerSearch(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerSearch>>>
export type SitesControllerSearchQueryError = unknown


export function useSitesControllerSearch<TData = Awaited<ReturnType<typeof sitesControllerSearch>>, TError = unknown>(
 params: undefined |  SitesControllerSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerSearch<TData = Awaited<ReturnType<typeof sitesControllerSearch>>, TError = unknown>(
 params?: SitesControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerSearch>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerSearch>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerSearch<TData = Awaited<ReturnType<typeof sitesControllerSearch>>, TError = unknown>(
 params?: SitesControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearch>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search/browse sites
 */

export function useSitesControllerSearch<TData = Awaited<ReturnType<typeof sitesControllerSearch>>, TError = unknown>(
 params?: SitesControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearch>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Snapshot of RYO tbl_business_descriptions — used by the Site edit form to let users pick the business_description_id sent up on calc creation.
 * @summary List RYO business descriptions
 */
export const sitesControllerGetBusinessDescriptions = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<RyoBusinessDescriptionDto[]>(
      {url: `/sites/business-descriptions`, method: 'GET', signal
    },
      );
    }
  



export const getSitesControllerGetBusinessDescriptionsQueryKey = () => {
    return [
    `/sites/business-descriptions`
    ] as const;
    }

    
export const getSitesControllerGetBusinessDescriptionsQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetBusinessDescriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>> = ({ signal }) => sitesControllerGetBusinessDescriptions(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetBusinessDescriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>>
export type SitesControllerGetBusinessDescriptionsQueryError = unknown


export function useSitesControllerGetBusinessDescriptions<TData = Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetBusinessDescriptions<TData = Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetBusinessDescriptions<TData = Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List RYO business descriptions
 */

export function useSitesControllerGetBusinessDescriptions<TData = Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetBusinessDescriptions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetBusinessDescriptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get service tracker data across all sites
 */
export const sitesControllerGetServiceTracker = (
    params?: SitesControllerGetServiceTrackerParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedServiceTrackerResponseDto>(
      {url: `/sites/service-tracker`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerGetServiceTrackerQueryKey = (params?: SitesControllerGetServiceTrackerParams,) => {
    return [
    `/sites/service-tracker`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerGetServiceTrackerQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError = unknown>(params?: SitesControllerGetServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetServiceTrackerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>> = ({ signal }) => sitesControllerGetServiceTracker(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetServiceTrackerQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>>
export type SitesControllerGetServiceTrackerQueryError = unknown


export function useSitesControllerGetServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError = unknown>(
 params: undefined |  SitesControllerGetServiceTrackerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError = unknown>(
 params?: SitesControllerGetServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError = unknown>(
 params?: SitesControllerGetServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get service tracker data across all sites
 */

export function useSitesControllerGetServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError = unknown>(
 params?: SitesControllerGetServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTracker>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetServiceTrackerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get service tracker summary counts
 */
export const sitesControllerGetServiceTrackerSummary = (
    params?: SitesControllerGetServiceTrackerSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ServiceTrackerSummaryDto>(
      {url: `/sites/service-tracker/summary`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerGetServiceTrackerSummaryQueryKey = (params?: SitesControllerGetServiceTrackerSummaryParams,) => {
    return [
    `/sites/service-tracker/summary`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerGetServiceTrackerSummaryQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError = unknown>(params?: SitesControllerGetServiceTrackerSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetServiceTrackerSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>> = ({ signal }) => sitesControllerGetServiceTrackerSummary(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetServiceTrackerSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>>
export type SitesControllerGetServiceTrackerSummaryQueryError = unknown


export function useSitesControllerGetServiceTrackerSummary<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError = unknown>(
 params: undefined |  SitesControllerGetServiceTrackerSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetServiceTrackerSummary<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError = unknown>(
 params?: SitesControllerGetServiceTrackerSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetServiceTrackerSummary<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError = unknown>(
 params?: SitesControllerGetServiceTrackerSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get service tracker summary counts
 */

export function useSitesControllerGetServiceTrackerSummary<TData = Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError = unknown>(
 params?: SitesControllerGetServiceTrackerSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetServiceTrackerSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetServiceTrackerSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Search service tracker data
 */
export const sitesControllerSearchServiceTracker = (
    params: SitesControllerSearchServiceTrackerParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SearchServiceTrackerResultDto>(
      {url: `/sites/service-tracker/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerSearchServiceTrackerQueryKey = (params?: SitesControllerSearchServiceTrackerParams,) => {
    return [
    `/sites/service-tracker/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerSearchServiceTrackerQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError = unknown>(params: SitesControllerSearchServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerSearchServiceTrackerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>> = ({ signal }) => sitesControllerSearchServiceTracker(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerSearchServiceTrackerQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>>
export type SitesControllerSearchServiceTrackerQueryError = unknown


export function useSitesControllerSearchServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError = unknown>(
 params: SitesControllerSearchServiceTrackerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerSearchServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError = unknown>(
 params: SitesControllerSearchServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerSearchServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError = unknown>(
 params: SitesControllerSearchServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search service tracker data
 */

export function useSitesControllerSearchServiceTracker<TData = Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError = unknown>(
 params: SitesControllerSearchServiceTrackerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerSearchServiceTracker>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerSearchServiceTrackerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Drives the modal UI. Adding a new mass-editable field requires only one registry entry in mass-update-fields.ts.
 * @summary List fields available in the Mass Update modal
 */
export const sitesControllerGetMassEditableFields = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MassEditableFieldDto[]>(
      {url: `/sites/mass-editable-fields`, method: 'GET', signal
    },
      );
    }
  



export const getSitesControllerGetMassEditableFieldsQueryKey = () => {
    return [
    `/sites/mass-editable-fields`
    ] as const;
    }

    
export const getSitesControllerGetMassEditableFieldsQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetMassEditableFieldsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>> = ({ signal }) => sitesControllerGetMassEditableFields(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetMassEditableFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>>
export type SitesControllerGetMassEditableFieldsQueryError = unknown


export function useSitesControllerGetMassEditableFields<TData = Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetMassEditableFields<TData = Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetMassEditableFields<TData = Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List fields available in the Mass Update modal
 */

export function useSitesControllerGetMassEditableFields<TData = Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetMassEditableFields>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetMassEditableFieldsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a site by ID
 */
export const sitesControllerFindOne = (
    siteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteDto>(
      {url: `/sites/${siteId}`, method: 'GET', signal
    },
      );
    }
  



export const getSitesControllerFindOneQueryKey = (siteId?: string,) => {
    return [
    `/sites/${siteId}`
    ] as const;
    }

    
export const getSitesControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerFindOne>>, TError = void>(siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerFindOneQueryKey(siteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerFindOne>>> = ({ signal }) => sitesControllerFindOne(siteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerFindOne>>>
export type SitesControllerFindOneQueryError = void


export function useSitesControllerFindOne<TData = Awaited<ReturnType<typeof sitesControllerFindOne>>, TError = void>(
 siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindOne<TData = Awaited<ReturnType<typeof sitesControllerFindOne>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindOne>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindOne<TData = Awaited<ReturnType<typeof sitesControllerFindOne>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a site by ID
 */

export function useSitesControllerFindOne<TData = Awaited<ReturnType<typeof sitesControllerFindOne>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindOne>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerFindOneQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a site
 */
export const sitesControllerUpdate = (
    siteId: string,
    updateSiteDto: UpdateSiteDto,
 ) => {
      
      
      return customInstance<SiteDto>(
      {url: `/sites/${siteId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSiteDto
    },
      );
    }
  


export const getSitesControllerUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdate>>, TError,{siteId: string;data: UpdateSiteDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdate>>, TError,{siteId: string;data: UpdateSiteDto}, TContext> => {

const mutationKey = ['sitesControllerUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerUpdate>>, {siteId: string;data: UpdateSiteDto}> = (props) => {
          const {siteId,data} = props ?? {};

          return  sitesControllerUpdate(siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerUpdate>>>
    export type SitesControllerUpdateMutationBody = UpdateSiteDto
    export type SitesControllerUpdateMutationError = void

    /**
 * @summary Update a site
 */
export const useSitesControllerUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdate>>, TError,{siteId: string;data: UpdateSiteDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerUpdate>>,
        TError,
        {siteId: string;data: UpdateSiteDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete a site
 */
export const sitesControllerRemove = (
    siteId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/sites/${siteId}`, method: 'DELETE'
    },
      );
    }
  


export const getSitesControllerRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerRemove>>, TError,{siteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerRemove>>, TError,{siteId: string}, TContext> => {

const mutationKey = ['sitesControllerRemove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerRemove>>, {siteId: string}> = (props) => {
          const {siteId} = props ?? {};

          return  sitesControllerRemove(siteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerRemove>>>
    
    export type SitesControllerRemoveMutationError = void

    /**
 * @summary Delete a site
 */
export const useSitesControllerRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerRemove>>, TError,{siteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerRemove>>,
        TError,
        {siteId: string},
        TContext
      > => {

      const mutationOptions = getSitesControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Assigns the energy manager from a Relay user (Firebase Auth) and marks the field as manually set so subsequent CRM webhooks won't overwrite it.
 * @summary Set the site energy manager (locks against CRM overwrite)
 */
export const sitesControllerSetEnergyManager = (
    siteId: string,
    setEnergyManagerDto: SetEnergyManagerDto,
 ) => {
      
      
      return customInstance<SiteDto>(
      {url: `/sites/${siteId}/energy-manager`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setEnergyManagerDto
    },
      );
    }
  


export const getSitesControllerSetEnergyManagerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerSetEnergyManager>>, TError,{siteId: string;data: SetEnergyManagerDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerSetEnergyManager>>, TError,{siteId: string;data: SetEnergyManagerDto}, TContext> => {

const mutationKey = ['sitesControllerSetEnergyManager'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerSetEnergyManager>>, {siteId: string;data: SetEnergyManagerDto}> = (props) => {
          const {siteId,data} = props ?? {};

          return  sitesControllerSetEnergyManager(siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerSetEnergyManagerMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerSetEnergyManager>>>
    export type SitesControllerSetEnergyManagerMutationBody = SetEnergyManagerDto
    export type SitesControllerSetEnergyManagerMutationError = void

    /**
 * @summary Set the site energy manager (locks against CRM overwrite)
 */
export const useSitesControllerSetEnergyManager = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerSetEnergyManager>>, TError,{siteId: string;data: SetEnergyManagerDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerSetEnergyManager>>,
        TError,
        {siteId: string;data: SetEnergyManagerDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerSetEnergyManagerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get bills for a site
 */
export const sitesControllerFindBillsForSite = (
    siteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BillDto[]>(
      {url: `/sites/${siteId}/bills`, method: 'GET', signal
    },
      );
    }
  



export const getSitesControllerFindBillsForSiteQueryKey = (siteId?: string,) => {
    return [
    `/sites/${siteId}/bills`
    ] as const;
    }

    
export const getSitesControllerFindBillsForSiteQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError = void>(siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerFindBillsForSiteQueryKey(siteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>> = ({ signal }) => sitesControllerFindBillsForSite(siteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerFindBillsForSiteQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>>
export type SitesControllerFindBillsForSiteQueryError = void


export function useSitesControllerFindBillsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError = void>(
 siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindBillsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindBillsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get bills for a site
 */

export function useSitesControllerFindBillsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindBillsForSite>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerFindBillsForSiteQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get site lists containing this site
 */
export const sitesControllerFindSiteListsForSite = (
    siteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteListDto[]>(
      {url: `/sites/${siteId}/site-lists`, method: 'GET', signal
    },
      );
    }
  



export const getSitesControllerFindSiteListsForSiteQueryKey = (siteId?: string,) => {
    return [
    `/sites/${siteId}/site-lists`
    ] as const;
    }

    
export const getSitesControllerFindSiteListsForSiteQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError = void>(siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerFindSiteListsForSiteQueryKey(siteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>> = ({ signal }) => sitesControllerFindSiteListsForSite(siteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerFindSiteListsForSiteQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>>
export type SitesControllerFindSiteListsForSiteQueryError = void


export function useSitesControllerFindSiteListsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError = void>(
 siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindSiteListsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerFindSiteListsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get site lists containing this site
 */

export function useSitesControllerFindSiteListsForSite<TData = Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError = void>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerFindSiteListsForSite>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerFindSiteListsForSiteQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Move a site between site lists
 */
export const sitesControllerMoveSiteToList = (
    siteId: string,
    moveSiteToListDto: MoveSiteToListDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/sites/${siteId}/move-to-list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moveSiteToListDto, signal
    },
      );
    }
  


export const getSitesControllerMoveSiteToListMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMoveSiteToList>>, TError,{siteId: string;data: MoveSiteToListDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMoveSiteToList>>, TError,{siteId: string;data: MoveSiteToListDto}, TContext> => {

const mutationKey = ['sitesControllerMoveSiteToList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerMoveSiteToList>>, {siteId: string;data: MoveSiteToListDto}> = (props) => {
          const {siteId,data} = props ?? {};

          return  sitesControllerMoveSiteToList(siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerMoveSiteToListMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerMoveSiteToList>>>
    export type SitesControllerMoveSiteToListMutationBody = MoveSiteToListDto
    export type SitesControllerMoveSiteToListMutationError = void

    /**
 * @summary Move a site between site lists
 */
export const useSitesControllerMoveSiteToList = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMoveSiteToList>>, TError,{siteId: string;data: MoveSiteToListDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerMoveSiteToList>>,
        TError,
        {siteId: string;data: MoveSiteToListDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerMoveSiteToListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Used by the Site List Mass Update flow. Stale siteIds are skipped, not errored.
 * @summary Apply the same edits to many sites at once
 */
export const sitesControllerMassUpdate = (
    massUpdateSitesDto: MassUpdateSitesDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MassUpdateSitesResultDto>(
      {url: `/sites/mass-update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: massUpdateSitesDto, signal
    },
      );
    }
  


export const getSitesControllerMassUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdate>>, TError,{data: MassUpdateSitesDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdate>>, TError,{data: MassUpdateSitesDto}, TContext> => {

const mutationKey = ['sitesControllerMassUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerMassUpdate>>, {data: MassUpdateSitesDto}> = (props) => {
          const {data} = props ?? {};

          return  sitesControllerMassUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerMassUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerMassUpdate>>>
    export type SitesControllerMassUpdateMutationBody = MassUpdateSitesDto
    export type SitesControllerMassUpdateMutationError = void

    /**
 * @summary Apply the same edits to many sites at once
 */
export const useSitesControllerMassUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdate>>, TError,{data: MassUpdateSitesDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerMassUpdate>>,
        TError,
        {data: MassUpdateSitesDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerMassUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resolves which contracts the selection's current/upcoming fields point at, and how many sites OUTSIDE the selection share them (shared-contract warning). No writes.
 * @summary Preview a bulk contract-field edit
 */
export const sitesControllerPreviewContractFields = (
    massUpdateContractFieldsDto: MassUpdateContractFieldsDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContractFieldsPreviewResultDto>(
      {url: `/sites/mass-update-contract-fields/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: massUpdateContractFieldsDto, signal
    },
      );
    }
  


export const getSitesControllerPreviewContractFieldsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerPreviewContractFields>>, TError,{data: MassUpdateContractFieldsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerPreviewContractFields>>, TError,{data: MassUpdateContractFieldsDto}, TContext> => {

const mutationKey = ['sitesControllerPreviewContractFields'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerPreviewContractFields>>, {data: MassUpdateContractFieldsDto}> = (props) => {
          const {data} = props ?? {};

          return  sitesControllerPreviewContractFields(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerPreviewContractFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerPreviewContractFields>>>
    export type SitesControllerPreviewContractFieldsMutationBody = MassUpdateContractFieldsDto
    export type SitesControllerPreviewContractFieldsMutationError = unknown

    /**
 * @summary Preview a bulk contract-field edit
 */
export const useSitesControllerPreviewContractFields = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerPreviewContractFields>>, TError,{data: MassUpdateContractFieldsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerPreviewContractFields>>,
        TError,
        {data: MassUpdateContractFieldsDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerPreviewContractFieldsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Each selected site resolves through its current/upcoming electricity contract. Shared contracts are written once and affect all linked sites. Sites with no contract in a phase, invalid date ranges, and discount on non-SME contracts, are reported, not errored.
 * @summary Bulk-edit current/upcoming contract fields (dates, SME discount) across many sites
 */
export const sitesControllerMassUpdateContractFields = (
    massUpdateContractFieldsDto: MassUpdateContractFieldsDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MassUpdateContractFieldsResultDto>(
      {url: `/sites/mass-update-contract-fields`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: massUpdateContractFieldsDto, signal
    },
      );
    }
  


export const getSitesControllerMassUpdateContractFieldsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdateContractFields>>, TError,{data: MassUpdateContractFieldsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdateContractFields>>, TError,{data: MassUpdateContractFieldsDto}, TContext> => {

const mutationKey = ['sitesControllerMassUpdateContractFields'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerMassUpdateContractFields>>, {data: MassUpdateContractFieldsDto}> = (props) => {
          const {data} = props ?? {};

          return  sitesControllerMassUpdateContractFields(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerMassUpdateContractFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerMassUpdateContractFields>>>
    export type SitesControllerMassUpdateContractFieldsMutationBody = MassUpdateContractFieldsDto
    export type SitesControllerMassUpdateContractFieldsMutationError = void

    /**
 * @summary Bulk-edit current/upcoming contract fields (dates, SME discount) across many sites
 */
export const useSitesControllerMassUpdateContractFields = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdateContractFields>>, TError,{data: MassUpdateContractFieldsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerMassUpdateContractFields>>,
        TError,
        {data: MassUpdateContractFieldsDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerMassUpdateContractFieldsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * For fields that are per-deal rather than per-site, so the same site in another tender is untouched. No preview step: a link has no blast radius outside its own deal.
 * @summary Mass-edit fields on the sites' links to one site list
 */
export const sitesControllerMassUpdateLinkFields = (
    massUpdateLinkFieldsDto: MassUpdateLinkFieldsDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MassUpdateLinkFieldsResultDto>(
      {url: `/sites/mass-update-link-fields`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: massUpdateLinkFieldsDto, signal
    },
      );
    }
  


export const getSitesControllerMassUpdateLinkFieldsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdateLinkFields>>, TError,{data: MassUpdateLinkFieldsDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdateLinkFields>>, TError,{data: MassUpdateLinkFieldsDto}, TContext> => {

const mutationKey = ['sitesControllerMassUpdateLinkFields'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerMassUpdateLinkFields>>, {data: MassUpdateLinkFieldsDto}> = (props) => {
          const {data} = props ?? {};

          return  sitesControllerMassUpdateLinkFields(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerMassUpdateLinkFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerMassUpdateLinkFields>>>
    export type SitesControllerMassUpdateLinkFieldsMutationBody = MassUpdateLinkFieldsDto
    export type SitesControllerMassUpdateLinkFieldsMutationError = void

    /**
 * @summary Mass-edit fields on the sites' links to one site list
 */
export const useSitesControllerMassUpdateLinkFields = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerMassUpdateLinkFields>>, TError,{data: MassUpdateLinkFieldsDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerMassUpdateLinkFields>>,
        TError,
        {data: MassUpdateLinkFieldsDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerMassUpdateLinkFieldsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Move multiple sites between site lists
 */
export const sitesControllerBatchMoveSitesToList = (
    batchMoveSitesToListDto: BatchMoveSitesToListDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/sites/batch-move-to-list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: batchMoveSitesToListDto, signal
    },
      );
    }
  


export const getSitesControllerBatchMoveSitesToListMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBatchMoveSitesToList>>, TError,{data: BatchMoveSitesToListDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBatchMoveSitesToList>>, TError,{data: BatchMoveSitesToListDto}, TContext> => {

const mutationKey = ['sitesControllerBatchMoveSitesToList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerBatchMoveSitesToList>>, {data: BatchMoveSitesToListDto}> = (props) => {
          const {data} = props ?? {};

          return  sitesControllerBatchMoveSitesToList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerBatchMoveSitesToListMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerBatchMoveSitesToList>>>
    export type SitesControllerBatchMoveSitesToListMutationBody = BatchMoveSitesToListDto
    export type SitesControllerBatchMoveSitesToListMutationError = void

    /**
 * @summary Move multiple sites between site lists
 */
export const useSitesControllerBatchMoveSitesToList = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerBatchMoveSitesToList>>, TError,{data: BatchMoveSitesToListDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerBatchMoveSitesToList>>,
        TError,
        {data: BatchMoveSitesToListDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerBatchMoveSitesToListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Check if an NMI already exists
 */
export const sitesControllerCheckNmiExists = (
    params: SitesControllerCheckNmiExistsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<NmiExistsResponseDto>(
      {url: `/sites/check-nmi-exists`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerCheckNmiExistsQueryKey = (params?: SitesControllerCheckNmiExistsParams,) => {
    return [
    `/sites/check-nmi-exists`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerCheckNmiExistsQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError = unknown>(params: SitesControllerCheckNmiExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerCheckNmiExistsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>> = ({ signal }) => sitesControllerCheckNmiExists(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerCheckNmiExistsQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>>
export type SitesControllerCheckNmiExistsQueryError = unknown


export function useSitesControllerCheckNmiExists<TData = Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError = unknown>(
 params: SitesControllerCheckNmiExistsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerCheckNmiExists<TData = Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError = unknown>(
 params: SitesControllerCheckNmiExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerCheckNmiExists<TData = Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError = unknown>(
 params: SitesControllerCheckNmiExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check if an NMI already exists
 */

export function useSitesControllerCheckNmiExists<TData = Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError = unknown>(
 params: SitesControllerCheckNmiExistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerCheckNmiExists>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerCheckNmiExistsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Import a site from CRM
 */
export const sitesControllerImportFromCrm = (
    importSiteFromCrmDto: ImportSiteFromCrmDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteDto>(
      {url: `/sites/import-from-crm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importSiteFromCrmDto, signal
    },
      );
    }
  


export const getSitesControllerImportFromCrmMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerImportFromCrm>>, TError,{data: ImportSiteFromCrmDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerImportFromCrm>>, TError,{data: ImportSiteFromCrmDto}, TContext> => {

const mutationKey = ['sitesControllerImportFromCrm'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerImportFromCrm>>, {data: ImportSiteFromCrmDto}> = (props) => {
          const {data} = props ?? {};

          return  sitesControllerImportFromCrm(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerImportFromCrmMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerImportFromCrm>>>
    export type SitesControllerImportFromCrmMutationBody = ImportSiteFromCrmDto
    export type SitesControllerImportFromCrmMutationError = void

    /**
 * @summary Import a site from CRM
 */
export const useSitesControllerImportFromCrm = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerImportFromCrm>>, TError,{data: ImportSiteFromCrmDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerImportFromCrm>>,
        TError,
        {data: ImportSiteFromCrmDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerImportFromCrmMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get account management services for a site
 */
export const sitesControllerGetAccountManagementServices = (
    siteId: string,
    params?: SitesControllerGetAccountManagementServicesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AccountManagementServiceDto[]>(
      {url: `/sites/${siteId}/account-management-services`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerGetAccountManagementServicesQueryKey = (siteId?: string,
    params?: SitesControllerGetAccountManagementServicesParams,) => {
    return [
    `/sites/${siteId}/account-management-services`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerGetAccountManagementServicesQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError = void>(siteId: string,
    params?: SitesControllerGetAccountManagementServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetAccountManagementServicesQueryKey(siteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>> = ({ signal }) => sitesControllerGetAccountManagementServices(siteId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetAccountManagementServicesQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>>
export type SitesControllerGetAccountManagementServicesQueryError = void


export function useSitesControllerGetAccountManagementServices<TData = Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError = void>(
 siteId: string,
    params: undefined |  SitesControllerGetAccountManagementServicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetAccountManagementServices<TData = Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetAccountManagementServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetAccountManagementServices<TData = Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetAccountManagementServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get account management services for a site
 */

export function useSitesControllerGetAccountManagementServices<TData = Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetAccountManagementServicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetAccountManagementServices>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetAccountManagementServicesQueryOptions(siteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create an account management service record
 */
export const sitesControllerCreateAccountManagementService = (
    siteId: string,
    createAccountManagementServiceDto: CreateAccountManagementServiceDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AccountManagementServiceDto>(
      {url: `/sites/${siteId}/account-management-services`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAccountManagementServiceDto, signal
    },
      );
    }
  


export const getSitesControllerCreateAccountManagementServiceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateAccountManagementService>>, TError,{siteId: string;data: CreateAccountManagementServiceDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateAccountManagementService>>, TError,{siteId: string;data: CreateAccountManagementServiceDto}, TContext> => {

const mutationKey = ['sitesControllerCreateAccountManagementService'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerCreateAccountManagementService>>, {siteId: string;data: CreateAccountManagementServiceDto}> = (props) => {
          const {siteId,data} = props ?? {};

          return  sitesControllerCreateAccountManagementService(siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerCreateAccountManagementServiceMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerCreateAccountManagementService>>>
    export type SitesControllerCreateAccountManagementServiceMutationBody = CreateAccountManagementServiceDto
    export type SitesControllerCreateAccountManagementServiceMutationError = void

    /**
 * @summary Create an account management service record
 */
export const useSitesControllerCreateAccountManagementService = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateAccountManagementService>>, TError,{siteId: string;data: CreateAccountManagementServiceDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerCreateAccountManagementService>>,
        TError,
        {siteId: string;data: CreateAccountManagementServiceDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerCreateAccountManagementServiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update an account management service record (e.g. status change)
 */
export const sitesControllerUpdateAccountManagementService = (
    siteId: string,
    serviceId: string,
    updateAccountManagementServiceDto: UpdateAccountManagementServiceDto,
 ) => {
      
      
      return customInstance<AccountManagementServiceDto>(
      {url: `/sites/${siteId}/account-management-services/${serviceId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountManagementServiceDto
    },
      );
    }
  


export const getSitesControllerUpdateAccountManagementServiceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateAccountManagementService>>, TError,{siteId: string;serviceId: string;data: UpdateAccountManagementServiceDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateAccountManagementService>>, TError,{siteId: string;serviceId: string;data: UpdateAccountManagementServiceDto}, TContext> => {

const mutationKey = ['sitesControllerUpdateAccountManagementService'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerUpdateAccountManagementService>>, {siteId: string;serviceId: string;data: UpdateAccountManagementServiceDto}> = (props) => {
          const {siteId,serviceId,data} = props ?? {};

          return  sitesControllerUpdateAccountManagementService(siteId,serviceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerUpdateAccountManagementServiceMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerUpdateAccountManagementService>>>
    export type SitesControllerUpdateAccountManagementServiceMutationBody = UpdateAccountManagementServiceDto
    export type SitesControllerUpdateAccountManagementServiceMutationError = void

    /**
 * @summary Update an account management service record (e.g. status change)
 */
export const useSitesControllerUpdateAccountManagementService = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateAccountManagementService>>, TError,{siteId: string;serviceId: string;data: UpdateAccountManagementServiceDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerUpdateAccountManagementService>>,
        TError,
        {siteId: string;serviceId: string;data: UpdateAccountManagementServiceDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerUpdateAccountManagementServiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete an account management service record
 */
export const sitesControllerDeleteAccountManagementService = (
    siteId: string,
    serviceId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/sites/${siteId}/account-management-services/${serviceId}`, method: 'DELETE'
    },
      );
    }
  


export const getSitesControllerDeleteAccountManagementServiceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteAccountManagementService>>, TError,{siteId: string;serviceId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteAccountManagementService>>, TError,{siteId: string;serviceId: string}, TContext> => {

const mutationKey = ['sitesControllerDeleteAccountManagementService'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerDeleteAccountManagementService>>, {siteId: string;serviceId: string}> = (props) => {
          const {siteId,serviceId} = props ?? {};

          return  sitesControllerDeleteAccountManagementService(siteId,serviceId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerDeleteAccountManagementServiceMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerDeleteAccountManagementService>>>
    
    export type SitesControllerDeleteAccountManagementServiceMutationError = void

    /**
 * @summary Delete an account management service record
 */
export const useSitesControllerDeleteAccountManagementService = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteAccountManagementService>>, TError,{siteId: string;serviceId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerDeleteAccountManagementService>>,
        TError,
        {siteId: string;serviceId: string},
        TContext
      > => {

      const mutationOptions = getSitesControllerDeleteAccountManagementServiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get unified activity feed for a site (notes, emails, services, disputes)
 */
export const sitesControllerGetSiteActivity = (
    siteId: string,
    params?: SitesControllerGetSiteActivityParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedActivityResponseDto>(
      {url: `/sites/${siteId}/activity`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerGetSiteActivityQueryKey = (siteId?: string,
    params?: SitesControllerGetSiteActivityParams,) => {
    return [
    `/sites/${siteId}/activity`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerGetSiteActivityQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError = void>(siteId: string,
    params?: SitesControllerGetSiteActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetSiteActivityQueryKey(siteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>> = ({ signal }) => sitesControllerGetSiteActivity(siteId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetSiteActivityQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>>
export type SitesControllerGetSiteActivityQueryError = void


export function useSitesControllerGetSiteActivity<TData = Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError = void>(
 siteId: string,
    params: undefined |  SitesControllerGetSiteActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteActivity<TData = Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteActivity<TData = Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get unified activity feed for a site (notes, emails, services, disputes)
 */

export function useSitesControllerGetSiteActivity<TData = Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteActivity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetSiteActivityQueryOptions(siteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get notes for a site
 */
export const sitesControllerGetSiteNotes = (
    siteId: string,
    params?: SitesControllerGetSiteNotesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<NoteDto[]>(
      {url: `/sites/${siteId}/notes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerGetSiteNotesQueryKey = (siteId?: string,
    params?: SitesControllerGetSiteNotesParams,) => {
    return [
    `/sites/${siteId}/notes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerGetSiteNotesQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError = void>(siteId: string,
    params?: SitesControllerGetSiteNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetSiteNotesQueryKey(siteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>> = ({ signal }) => sitesControllerGetSiteNotes(siteId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetSiteNotesQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>>
export type SitesControllerGetSiteNotesQueryError = void


export function useSitesControllerGetSiteNotes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError = void>(
 siteId: string,
    params: undefined |  SitesControllerGetSiteNotesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteNotes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteNotes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get notes for a site
 */

export function useSitesControllerGetSiteNotes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteNotesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteNotes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetSiteNotesQueryOptions(siteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a note for a site
 */
export const sitesControllerCreateSiteNote = (
    siteId: string,
    createNoteDto: CreateNoteDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<NoteDto>(
      {url: `/sites/${siteId}/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createNoteDto, signal
    },
      );
    }
  


export const getSitesControllerCreateSiteNoteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateSiteNote>>, TError,{siteId: string;data: CreateNoteDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateSiteNote>>, TError,{siteId: string;data: CreateNoteDto}, TContext> => {

const mutationKey = ['sitesControllerCreateSiteNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerCreateSiteNote>>, {siteId: string;data: CreateNoteDto}> = (props) => {
          const {siteId,data} = props ?? {};

          return  sitesControllerCreateSiteNote(siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerCreateSiteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerCreateSiteNote>>>
    export type SitesControllerCreateSiteNoteMutationBody = CreateNoteDto
    export type SitesControllerCreateSiteNoteMutationError = void

    /**
 * @summary Create a note for a site
 */
export const useSitesControllerCreateSiteNote = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateSiteNote>>, TError,{siteId: string;data: CreateNoteDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerCreateSiteNote>>,
        TError,
        {siteId: string;data: CreateNoteDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerCreateSiteNoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a note
 */
export const sitesControllerUpdateSiteNote = (
    siteId: string,
    noteId: string,
    updateNoteDto: UpdateNoteDto,
 ) => {
      
      
      return customInstance<NoteDto>(
      {url: `/sites/${siteId}/notes/${noteId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateNoteDto
    },
      );
    }
  


export const getSitesControllerUpdateSiteNoteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateSiteNote>>, TError,{siteId: string;noteId: string;data: UpdateNoteDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateSiteNote>>, TError,{siteId: string;noteId: string;data: UpdateNoteDto}, TContext> => {

const mutationKey = ['sitesControllerUpdateSiteNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerUpdateSiteNote>>, {siteId: string;noteId: string;data: UpdateNoteDto}> = (props) => {
          const {siteId,noteId,data} = props ?? {};

          return  sitesControllerUpdateSiteNote(siteId,noteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerUpdateSiteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerUpdateSiteNote>>>
    export type SitesControllerUpdateSiteNoteMutationBody = UpdateNoteDto
    export type SitesControllerUpdateSiteNoteMutationError = void

    /**
 * @summary Update a note
 */
export const useSitesControllerUpdateSiteNote = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateSiteNote>>, TError,{siteId: string;noteId: string;data: UpdateNoteDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerUpdateSiteNote>>,
        TError,
        {siteId: string;noteId: string;data: UpdateNoteDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerUpdateSiteNoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete a note
 */
export const sitesControllerDeleteSiteNote = (
    siteId: string,
    noteId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/sites/${siteId}/notes/${noteId}`, method: 'DELETE'
    },
      );
    }
  


export const getSitesControllerDeleteSiteNoteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteSiteNote>>, TError,{siteId: string;noteId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteSiteNote>>, TError,{siteId: string;noteId: string}, TContext> => {

const mutationKey = ['sitesControllerDeleteSiteNote'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerDeleteSiteNote>>, {siteId: string;noteId: string}> = (props) => {
          const {siteId,noteId} = props ?? {};

          return  sitesControllerDeleteSiteNote(siteId,noteId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerDeleteSiteNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerDeleteSiteNote>>>
    
    export type SitesControllerDeleteSiteNoteMutationError = void

    /**
 * @summary Delete a note
 */
export const useSitesControllerDeleteSiteNote = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteSiteNote>>, TError,{siteId: string;noteId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerDeleteSiteNote>>,
        TError,
        {siteId: string;noteId: string},
        TContext
      > => {

      const mutationOptions = getSitesControllerDeleteSiteNoteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get disputes for a site, newest raised first
 */
export const sitesControllerGetSiteDisputes = (
    siteId: string,
    params?: SitesControllerGetSiteDisputesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteDisputeDto[]>(
      {url: `/sites/${siteId}/disputes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerGetSiteDisputesQueryKey = (siteId?: string,
    params?: SitesControllerGetSiteDisputesParams,) => {
    return [
    `/sites/${siteId}/disputes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerGetSiteDisputesQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError = void>(siteId: string,
    params?: SitesControllerGetSiteDisputesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetSiteDisputesQueryKey(siteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>> = ({ signal }) => sitesControllerGetSiteDisputes(siteId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetSiteDisputesQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>>
export type SitesControllerGetSiteDisputesQueryError = void


export function useSitesControllerGetSiteDisputes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError = void>(
 siteId: string,
    params: undefined |  SitesControllerGetSiteDisputesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteDisputes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteDisputesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteDisputes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteDisputesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get disputes for a site, newest raised first
 */

export function useSitesControllerGetSiteDisputes<TData = Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteDisputesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteDisputes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetSiteDisputesQueryOptions(siteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * raisedAt and raisedBy are stamped server-side from the request time and user.
 * @summary Raise a dispute against a site
 */
export const sitesControllerCreateSiteDispute = (
    siteId: string,
    createSiteDisputeDto: CreateSiteDisputeDto,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteDisputeDto>(
      {url: `/sites/${siteId}/disputes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSiteDisputeDto, signal
    },
      );
    }
  


export const getSitesControllerCreateSiteDisputeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateSiteDispute>>, TError,{siteId: string;data: CreateSiteDisputeDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateSiteDispute>>, TError,{siteId: string;data: CreateSiteDisputeDto}, TContext> => {

const mutationKey = ['sitesControllerCreateSiteDispute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerCreateSiteDispute>>, {siteId: string;data: CreateSiteDisputeDto}> = (props) => {
          const {siteId,data} = props ?? {};

          return  sitesControllerCreateSiteDispute(siteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerCreateSiteDisputeMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerCreateSiteDispute>>>
    export type SitesControllerCreateSiteDisputeMutationBody = CreateSiteDisputeDto
    export type SitesControllerCreateSiteDisputeMutationError = void

    /**
 * @summary Raise a dispute against a site
 */
export const useSitesControllerCreateSiteDispute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerCreateSiteDispute>>, TError,{siteId: string;data: CreateSiteDisputeDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerCreateSiteDispute>>,
        TError,
        {siteId: string;data: CreateSiteDisputeDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerCreateSiteDisputeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resolving stamps resolvedAt and resolvedBy server-side; reopening clears them.
 * @summary Edit, resolve or reopen a dispute
 */
export const sitesControllerUpdateSiteDispute = (
    siteId: string,
    disputeId: string,
    updateSiteDisputeDto: UpdateSiteDisputeDto,
 ) => {
      
      
      return customInstance<SiteDisputeDto>(
      {url: `/sites/${siteId}/disputes/${disputeId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateSiteDisputeDto
    },
      );
    }
  


export const getSitesControllerUpdateSiteDisputeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateSiteDispute>>, TError,{siteId: string;disputeId: string;data: UpdateSiteDisputeDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateSiteDispute>>, TError,{siteId: string;disputeId: string;data: UpdateSiteDisputeDto}, TContext> => {

const mutationKey = ['sitesControllerUpdateSiteDispute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerUpdateSiteDispute>>, {siteId: string;disputeId: string;data: UpdateSiteDisputeDto}> = (props) => {
          const {siteId,disputeId,data} = props ?? {};

          return  sitesControllerUpdateSiteDispute(siteId,disputeId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerUpdateSiteDisputeMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerUpdateSiteDispute>>>
    export type SitesControllerUpdateSiteDisputeMutationBody = UpdateSiteDisputeDto
    export type SitesControllerUpdateSiteDisputeMutationError = void

    /**
 * @summary Edit, resolve or reopen a dispute
 */
export const useSitesControllerUpdateSiteDispute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerUpdateSiteDispute>>, TError,{siteId: string;disputeId: string;data: UpdateSiteDisputeDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerUpdateSiteDispute>>,
        TError,
        {siteId: string;disputeId: string;data: UpdateSiteDisputeDto},
        TContext
      > => {

      const mutationOptions = getSitesControllerUpdateSiteDisputeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Soft delete: the record is kept with archivedAt / archivedBy and leaves the feed and the roll-up.
 * @summary Delete a dispute
 */
export const sitesControllerDeleteSiteDispute = (
    siteId: string,
    disputeId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/sites/${siteId}/disputes/${disputeId}`, method: 'DELETE'
    },
      );
    }
  


export const getSitesControllerDeleteSiteDisputeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteSiteDispute>>, TError,{siteId: string;disputeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteSiteDispute>>, TError,{siteId: string;disputeId: string}, TContext> => {

const mutationKey = ['sitesControllerDeleteSiteDispute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerDeleteSiteDispute>>, {siteId: string;disputeId: string}> = (props) => {
          const {siteId,disputeId} = props ?? {};

          return  sitesControllerDeleteSiteDispute(siteId,disputeId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerDeleteSiteDisputeMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerDeleteSiteDispute>>>
    
    export type SitesControllerDeleteSiteDisputeMutationError = void

    /**
 * @summary Delete a dispute
 */
export const useSitesControllerDeleteSiteDispute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerDeleteSiteDispute>>, TError,{siteId: string;disputeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerDeleteSiteDispute>>,
        TError,
        {siteId: string;disputeId: string},
        TContext
      > => {

      const mutationOptions = getSitesControllerDeleteSiteDisputeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Restore a soft-deleted dispute
 */
export const sitesControllerRestoreSiteDispute = (
    siteId: string,
    disputeId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteDisputeDto>(
      {url: `/sites/${siteId}/disputes/${disputeId}/restore`, method: 'POST', signal
    },
      );
    }
  


export const getSitesControllerRestoreSiteDisputeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerRestoreSiteDispute>>, TError,{siteId: string;disputeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sitesControllerRestoreSiteDispute>>, TError,{siteId: string;disputeId: string}, TContext> => {

const mutationKey = ['sitesControllerRestoreSiteDispute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sitesControllerRestoreSiteDispute>>, {siteId: string;disputeId: string}> = (props) => {
          const {siteId,disputeId} = props ?? {};

          return  sitesControllerRestoreSiteDispute(siteId,disputeId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SitesControllerRestoreSiteDisputeMutationResult = NonNullable<Awaited<ReturnType<typeof sitesControllerRestoreSiteDispute>>>
    
    export type SitesControllerRestoreSiteDisputeMutationError = void

    /**
 * @summary Restore a soft-deleted dispute
 */
export const useSitesControllerRestoreSiteDispute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sitesControllerRestoreSiteDispute>>, TError,{siteId: string;disputeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sitesControllerRestoreSiteDispute>>,
        TError,
        {siteId: string;disputeId: string},
        TContext
      > => {

      const mutationOptions = getSitesControllerRestoreSiteDisputeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get emails for a site
 */
export const sitesControllerGetSiteEmails = (
    siteId: string,
    params?: SitesControllerGetSiteEmailsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmailDto[]>(
      {url: `/sites/${siteId}/emails`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSitesControllerGetSiteEmailsQueryKey = (siteId?: string,
    params?: SitesControllerGetSiteEmailsParams,) => {
    return [
    `/sites/${siteId}/emails`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSitesControllerGetSiteEmailsQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError = void>(siteId: string,
    params?: SitesControllerGetSiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetSiteEmailsQueryKey(siteId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>> = ({ signal }) => sitesControllerGetSiteEmails(siteId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetSiteEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>>
export type SitesControllerGetSiteEmailsQueryError = void


export function useSitesControllerGetSiteEmails<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError = void>(
 siteId: string,
    params: undefined |  SitesControllerGetSiteEmailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteEmails<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteEmails<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get emails for a site
 */

export function useSitesControllerGetSiteEmails<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError = void>(
 siteId: string,
    params?: SitesControllerGetSiteEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmails>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetSiteEmailsQueryOptions(siteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get a single email with full body text
 */
export const sitesControllerGetSiteEmail = (
    siteId: string,
    emailId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<EmailDto>(
      {url: `/sites/${siteId}/emails/${emailId}`, method: 'GET', signal
    },
      );
    }
  



export const getSitesControllerGetSiteEmailQueryKey = (siteId?: string,
    emailId?: string,) => {
    return [
    `/sites/${siteId}/emails/${emailId}`
    ] as const;
    }

    
export const getSitesControllerGetSiteEmailQueryOptions = <TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError = void>(siteId: string,
    emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSitesControllerGetSiteEmailQueryKey(siteId,emailId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>> = ({ signal }) => sitesControllerGetSiteEmail(siteId,emailId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(siteId && emailId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SitesControllerGetSiteEmailQueryResult = NonNullable<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>>
export type SitesControllerGetSiteEmailQueryError = void


export function useSitesControllerGetSiteEmail<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError = void>(
 siteId: string,
    emailId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteEmail<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError = void>(
 siteId: string,
    emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>,
          TError,
          Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSitesControllerGetSiteEmail<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError = void>(
 siteId: string,
    emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single email with full body text
 */

export function useSitesControllerGetSiteEmail<TData = Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError = void>(
 siteId: string,
    emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof sitesControllerGetSiteEmail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSitesControllerGetSiteEmailQueryOptions(siteId,emailId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




